import React from 'react';

import cx from 'classnames';

import { IActionButton } from 'utils/itineraryDetails/types';
import { checkIsWebview } from 'utils/mobileApplication';

import s from './index.module.css';
import { ActionButton } from './shared';

type Props = {
  actionButtonOptions: IActionButton;
};

function PageFooter({ actionButtonOptions }: Props) {
  const isWebview = checkIsWebview();

  return (
    <div className={cx(s.footerContainer, isWebview && s.webviewFooter)}>
      <ActionButton {...actionButtonOptions} />
    </div>
  );
}

export { PageFooter };
